import React, { Component } from 'react';
import RecapContainer from '../../containers/recapContainer';

class KeyboardRecap extends Component {
  renderPause() {
    return (
      <div>
        <p>
          Did you successfully pick a delicious lunch option?
        </p>
        <p>
          Check in with the person across from you.
          Did they have a similar experience?
        </p>
        <p>
          These lunch sign-up forms feature custom-built dropdown menus for selecting
          food options, and they work perfectly with a functional mouse. But only 
          the developer for the form on {' '}
          <em>{this.props.accessible ? 'your' : 'the other person\'s'} screen</em>{' '}
          built it with both mouse and keyboard users in mind.
        </p>
      </div>
    );
  }

  renderRecap() {
    return (
      <div>
        <p>
          Some people navigate primarily with a mouse, some primarily with a keyboard.
        </p>
        <p>
          Ensure every user can complete their tasks regardless of which input device they use.
        </p>
      </div>
    );
  }

  render() {
    return (
      <RecapContainer
        accessible={this.props.accessible}
        title='Keyboard Interactivity'
      	nextLabel='Review'
      	nextFunc={this.props.nextFunc}
        pause={this.renderPause()}
        recap={this.renderRecap()}
      />
    );
  }
}

export default KeyboardRecap;



// WEBPACK FOOTER //
// ./src/steps/keyboard/recap.js